import React, { createContext, useState, useContext } from "react";
import { fetchExamLanguages } from "../services/service";

const LanguagesContext = createContext();

function LanguagesProvider({ children }) {
  const [languages, setLanguages] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const fetchLanguagesData = async (examId) => {
    try {
      const languageData = await fetchExamLanguages(examId);
      if (languageData && languageData.length > 0) {
        const language = languageData.map((lang) => ({
          label: lang.language.charAt(0).toUpperCase() + lang.language.slice(1),
          value: lang.language,
        }));
        sessionStorage.setItem("language", JSON.stringify(language));
        setLanguages(language);
        if (sessionStorage.getItem("selectedLanguage")) {
          const selectedLanguage = JSON.parse(
            sessionStorage.getItem("selectedLanguage")
          );
          setSelectedLanguage(selectedLanguage.value);
        } else {
          setSelectedLanguage(language[0].value);
          sessionStorage.setItem(
            "selectedLanguage",
            JSON.stringify(language[0])
          );
        }
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  const handleChange = (event) => {
    setSelectedLanguage(event.target.value);
    const selectedObj = languages.find((l) => l.value === event.target.value);
    sessionStorage.setItem("selectedLanguage", JSON.stringify(selectedObj));
  };

  return (
    <LanguagesContext.Provider
      value={{ languages, selectedLanguage, fetchLanguagesData, handleChange }}
    >
      {children}
    </LanguagesContext.Provider>
  );
}

const useLanguages = () => {
  return useContext(LanguagesContext);
};

export { useLanguages };
export default LanguagesProvider;

// Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam perspiciatis asperiores quam neque excepturi quae omnis cum reiciendis inventore esse sit, hic voluptates. Quasi architecto libero molestias vel dicta sunt rem aut? Fuga numquam culpa reprehenderit ex assumenda impedit, sint, ad soluta quos eum cumque nobis ea iusto commodi sed.